import { Routes } from '@angular/router';
import { StandaloneGuard } from './standalone/standalone-guard';
import { AppRoutes } from './shared/utils/enums/routes.enum';
import { provideSmartRecoStore } from '@app/pages/smart-reco/smart-reco.routes';
import { LeaveShareRecoService } from './pages/share-recommendation/leave-share-recommendation.service';

export const APP_ROUTES: Routes = [
  {
    path: AppRoutes.CALLBACK,
    loadComponent: () => import(`@app/pages/okta/callback.component`).then((c) => c.OktaCallbackComponent),
    providers: [StandaloneGuard],
  },
  {
    path: AppRoutes.BROWSER_DEPRECATED,
    loadComponent: () => import(`@app/pages/browser-deprecation/browser-deprecation.component`).then((c) => c.BrowserDeprecationComponent),
    providers: [StandaloneGuard],
  },
  {
    path: AppRoutes.ACCESS_DENIED,
    loadComponent: () =>
      import(`@app/standalone/standalone-access-denied/standalone-access-denied.component`).then((c) => c.StandaloneAccessDeniedComponent),
    providers: [StandaloneGuard],
  },
  {
    path: '',
    loadComponent: () => import(`@app/standalone/srs-main-page/srs-main-page.component`).then((c) => c.SrsMainPageComponent),
    canActivate: [StandaloneGuard],
    runGuardsAndResolvers: 'always',
    providers: [StandaloneGuard],
    children: [
      {
        path: '',
        loadComponent: () => import(`@app/standalone/srs-init.component`).then((c) => c.SrsInitComponent),
      },
      {
        path: AppRoutes.SMART_RECO,
        loadChildren: () => import(`@app/pages/smart-reco/smart-reco.routes`).then((c) => c.routes),
        providers: provideSmartRecoStore(),
      },
      {
        path: AppRoutes.ALLOWANCE,
        loadChildren: () => import(`@app/pages/allowance/allowance.routes`).then((c) => c.routes),
      },
      {
        path: AppRoutes.SHARE_RECOMMENDATION,
        loadComponent: () =>
          import('app/pages/share-recommendation/share-recommendation.component').then((c) => c.ShareRecommendationComponent),
        canDeactivate: [LeaveShareRecoService],
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
